export default __webpack_public_path__ + "static/cn-nav-6babc8d452e48c7a91ec08fd6bcd8d07.png";